import React from 'react';
import moment from 'moment/moment';

const ReportRows = ({
  action: report,
  setDangerShow,
  setCurrentReport,
  setGenerateStatus,
  openLink,
}) => {
  const openReport = id => {
    const newWindow = window.open('', '_blank');
    if (!newWindow) {
      console.warn('Popup blocked');
      return;
    }
    openLink(id)
      .unwrap()
      .then(res => {
        if (res?.data?.url) {
          newWindow.location.href = `${res.data.url}?time=${Date.now()}`;
        } else {
          newWindow.close();
        }
      })
      .catch(error => {
        console.error('Failed to open the link:', error);
        newWindow.close();
      });
  };

  return (
    <div className='report__row' key={report?.id}>
      <div className='report__td'>{report?.name}</div>
      <div className='report__td'>
        {moment(report?.updated_at).format('MM/DD/YY HH:mm')}
      </div>
      <div className='report__td'>{report?.facility?.name}</div>
      <div className='report__td'>{report?.year}</div>
      <div className='report__td'>
        {report?.month_to === report?.month_from
          ? report?.month_from
          : `${report?.month_from} - ${report?.month_to}`}
      </div>
      <div className='report__td'>{report?.created_by?.name}</div>
      {report?.file_name === 'wait' ? (
        <div className='report__td small'>Generating Report</div>
      ) : report?.file_name === 'has_errors' ? (
        <div className='report__td small'>Has Errors</div>
      ) : report?.file_name && report?.file_name?.length > 0 ? (
        <div
          className='report__td'
          rel='noreferrer'
          onClick={() => openReport(report?.id)}
        >
          <img src='/assets/icons/Download.svg' alt='icon' />
        </div>
      ) : (
        <div className='report__td'>NO DATA</div>
      )}
      <div className='report__td action'>
        <img
          width={24}
          height={24}
          src='/assets/icons/trash-2.svg'
          alt='icon'
          onClick={() => {
            setDangerShow(true);
            setCurrentReport(report.id);
          }}
        />
        <img
          width={24}
          height={24}
          src='/assets/icons/rotate-pdf.svg'
          alt='icon'
          onClick={() => {
            setGenerateStatus(true);
            setCurrentReport(report.id);
          }}
        />
      </div>
    </div>
  );
};

export default ReportRows;
